export default {
	api: {
		updated: 'Record updated'
	},
	common: {
		ok: 'Ok',
		save: 'Save',
		saveAndNext: 'Save and next',
		yes: 'Yes',
		no: 'No',
		cancel: 'Cancel',
		update: 'Update',
		create: 'Create',
		back: 'Back',
		delete: 'Delete',
		send: 'Send',
		search: 'Search...',
		all: 'All',
		none: 'None',
		unknown: 'Unknown',
		assigned: 'Assigned',
		not_assigned: 'Not assigned',
		please_select: 'Please select',
		saved: 'Saved',
		locked: 'Locked',
		to_login: 'To login',
		expired_session: 'Your session has expired. Please log in again.',
		clear_image: 'Clear image',
		preview: 'Preview',
		edit: 'Edit',
		edit_avatar: 'Edit avatar',
		options: 'Options',
		service_not_available: 'An error occurred, please try again later.',
		created: 'Created',
		updated: 'Updated'
	},
	generic: {
		loading: 'Loading',
		previous: 'Previous',
		next: 'Next',
		calender: 'Calendar',
		today: 'Today',
		week: 'Week',
		add_event: 'Add event',
		select_language: 'Select language'
	},
	layouts: {
		header: {
			i18n: {
				locale: {
					en: 'English',
					de: 'German'
				}
			},
			location: {
				enable: 'Enable',
				disable: 'Disable',
				force_update: 'Update location now'
			},
			notifications: {
				newNotifications: 'No notifications | One notification | {count} notifications',
				viewAll: 'View all'
			},
			profile: {
				profile: 'Profile',
				settings: 'Settings',
				darkMode: 'Dark',
				lightMode: 'Light',
				autoMode: 'Auto',
				theme: 'Theme',
				notifications: 'Notifications',
				reverbPing: 'Check realtime connection',
				signOut: 'Sign out'
			},
			search: {
				placeholder: 'Search...'
			}
		}
	},
	pages: {
		admin: {
			teams: {
				title: 'Teams',
				create: 'Create team',
				edit: 'Edit team',
				users: 'People',
				events: 'Events'
			},
			events: {
				title: 'Events',
				create: 'Create event',
				edit: 'Edit event',
				teams: 'Teams'
			},
			users: {
				title: 'People',
				teams: 'Teams',
				events: 'Events',
				label: {
					emailNotVerified: 'E-mail not verified',
					is_locked: 'Locked'
				},
				resend_invitation: 'Resend credentials',
				resend_invitation_confirm:
					"Resend the credentials to '{name}'? Anyone who has never signed in receives new credentials, otherwise a password reset link is sent.",
				invitation_sent: 'The invitation with new credentials has been sent by e-mail.',
				password_reset_sent: 'A password reset link has been sent by e-mail.',
				resend_failed: 'The e-mail could not be sent.'
			},
			settings: {
				roles_and_permissions: {
					roles: 'Roles',
					permissions: 'Permissions'
				},
				context_roles_and_permissions: {
					context_roles: 'Context roles',
					context_permissions: 'Context permissions'
				},
				map: {
					general: 'General',
					preview: 'Preview',
					layer: 'Layers',
					overlays: 'Overlays'
				},
				webhooks: {
					title: 'Webhooks'
				}
			},
			webhook_requests: {
				title: 'Webhook requests'
			}
		},
		context: {
			users: {
				title: 'People'
			}
		},
		me: {
			notifications: {
				title: 'Notifications',
				email: {
					title: 'E-mail',
					text: 'Activate or deactivate your e-mail notifications here.',
					activate: 'Activate e-mail notifications'
				},
				email_activate: 'Activate e-mail notifications',
				pushover: {
					title: 'Pushover',
					text: 'Use Pushover as a notification channel',
					activate: 'Activate the Pushover notification channel',
					user_key: 'Pushover user key'
				}
			},
			security: {
				title: 'Security',
				pat: {
					title: 'PAT',
					text: 'Manage your private access tokens'
				}
			}
		},
		profile: {
			firstname: 'First name',
			lastname: 'Last name',
			email: 'E-mail address',
			current_password: 'Current password',
			new_password: 'New password',
			password: 'Password',
			password_text: 'Ensure your account is using a long, random password to stay secure.',
			password_confirm: 'Confirm new password',
			profile_updated: 'Profile updated',
			password_updated: 'Password updated',
			avatar: 'Avatar',
			avatar_text: 'Set a custom avatar image for your profile.',
			profile: 'Profile',
			profile_text: "Update your account's profile information and e-mail address."
		},
		auth: {
			login: {
				title: 'Please log into your account',
				text: 'Please enter your credentials.',
				email: 'E-mail address',
				password: 'Password',
				rememberMe: 'Stay signed in',
				signIn: 'Sign in',
				loading: 'Signing in...',
				register: {
					text: 'Not registered yet?',
					link: 'Register with e-mail'
				},
				passwordReset: {
					link: 'Forgot your password?'
				},
				error: {
					invalidLogin: 'Invalid e-mail address or password.'
					//notVerified: 'Your e-mail address has not been verified yet. Please use the link in the confirmation e-mail.',
					//ylocked: 'Your login has been deactivated. Please contact support@crewadmin.de',
				},
				social: {
					divider: 'or',
					google: 'Sign in with Google',
					microsoft: 'Sign in with Microsoft',
					apple: 'Sign in with Apple',
					keycloak: 'Sign in with Keycloak',
					authentik: 'Sign in with Authentik'
				}
				//resendVerification: 'Resend confirmation e-mail.',
			},
			register: {
				title: 'Create your account',
				text: 'Please enter your data.',
				firstname: 'First name',
				lastname: 'Last name',
				email: 'E-mail address',
				password: 'Password',
				confirmPassword: 'Confirm password',
				acceptTerms: 'I have read the <a href="{href}">privacy policy</a>.',
				signUp: 'Register with e-mail',
				disabled: 'Registration is disabled',
				login: {
					text: 'Already have an account?',
					link: 'Sign in with e-mail or SSO'
				},
				error: {
					emailExists: 'This e-mail address is already registered.'
				},
				mailTaken: 'This e-mail address is already in use.',
				completedText: 'Please check your e-mail inbox. We have sent you an e-mail with instructions to sign in.'
			},
			passwordReset: {
				title: 'Reset password',
				text: 'Please enter your e-mail address and we will send you instructions to reset your password.',
				email: 'E-mail address:',
				sendResetLink: 'Continue',
				completedText:
					'Please check your e-mail inbox. We have sent you an e-mail with instructions to reset your password.'
			},
			newPassword: {
				title: 'Reset password',
				text: 'Please enter a new password.',
				email: 'E-mail address:',
				newPassword: 'New password:',
				confirmPassword: 'Confirm new password:',
				setNewPassword: 'Continue'
			}
		},
		settings: {
			general: {
				title: 'General'
			},
			announcements: {
				title: 'Announcements'
			},
			users: {
				title: 'People'
			},
			events: {
				title: 'Events'
			},
			teams: {
				title: 'Teams'
			}
		},
		map: {
			context_menu: {
				center: 'Center here',
				copy_coordinates: 'Copy coordinates'
			}
		},
		note_book: {
			table_of_content: 'Overview',
			add_page: 'Add page'
		}
	},
	validations: {
		required: 'Input required',
		invalidEmail: 'Invalid e-mail address'
	},
	sidebar: {
		home: 'Overview',
		blank: 'Blank',
		cards: 'Cards',
		graph: 'Graph',
		map: 'Map',
		table: 'Table',
		users: 'People',
		teams: 'Teams',
		events: 'Events',
		settings: 'Settings',
		development: 'Development',
		swagger: 'Swagger UI',
		support: 'Support'
	},
	table: {
		elementsPerPage: 'Entries per page',
		currentPageOfTotalPages: 'Page {current} of {total}',
		currentElementsOfTotalElements: 'Entries {from} to {to} of {total}',
		currentElementsOfTotalElementsFilteredNote: '(filtered from {total})',
		noElements: 'No entries'
	},
	components: {
		selectUser: {
			placeholder: 'Select person...'
		}
	},
	filter: {
		status: 'Status',
		role: 'Role',
		user: 'Responsible person'
	},
	modal: {
		admin: {
			editUser: {
				create: 'Invite new person',
				edit: 'Edit person'
			},
			editTeam: {
				create: 'Create new team',
				edit: 'Edit team',
				users: 'People'
			},
			editEvent: {
				create: 'Create new event',
				edit: 'Edit event',
				users: 'People',
				teams: 'Teams'
			},
			editRole: {
				create: 'Create new role',
				edit: 'Edit role',
				permissions: 'Permissions'
			},
			editWebhook: {
				create: 'Create new webhook',
				edit: 'Edit webhook',
				auth_none: 'None',
				auth_basic: 'HTTP Basic',
				auth_token: 'Query token',
				webhook_url: 'Webhook URL',
				headers: 'Headers'
			},
			deleteRole: {
				title: 'Delete role',
				text: "Do you really want to delete the role '{item}'?"
			},
			editContextRole: {
				create: 'Create new context role',
				edit: 'Edit context role',
				permissions: 'Permissions'
			},
			deleteContextRole: {
				title: 'Delete context role',
				text: "Do you really want to delete the context-based role '{item}'?"
			}
		},
		editAnnouncement: {
			create: 'Create new announcement',
			edit: 'Edit announcement'
		},
		addUser: {
			title: 'Add person',
			input: 'Select person'
		},
		inviteUser: {
			title: 'Invite or add person',
			input: 'Search by name or e-mail address',
			context_role: 'Role'
		},
		inviteTeam: {
			title: 'Add team'
		},
		editEventLayer: {
			create: 'Create new layer',
			edit: 'Edit layer'
		},
		editEventOverlay: {
			create: 'Create new overlay',
			edit: 'Edit overlay'
		},
		removeEventLayer: {
			title: 'Delete map layer',
			text: "Do you really want to delete the map layer '{item}'?"
		},
		editMarker: {
			create: 'Create new marker',
			edit: 'Edit marker'
		},
		removeMarker: {
			title: 'Delete marker',
			text: "Do you really want to delete the marker '{item}'?"
		},
		imageUpload: {
			resize_error: 'The image could not be processed.',
			select_image_file: 'Please select an image file.'
		},
		deleteArticleImage: {
			title: 'Delete image',
			text: 'Do you really want to delete the article image?'
		},
		showLocation: {
			orders: 'Orders',
			cart_items: 'Order items'
		},
		tableColumnFilter: {
			title: 'Table column filter',
			name: 'Name',
			show: 'Show'
		}
	},
	confirm: {
		remove_announcement: 'Remove announcement',
		remove_announcement_title: `Remove the announcement "{title}"?`,
		removeEventOverlay: {
			title: 'Delete overlay',
			text: 'Do you really want to remove the overlay "{name}"?'
		},
		deleteWebhook: {
			title: 'Delete webhook',
			text: 'Do you really want to delete the webhook "{item}"? All associated webhook requests will be deleted as well.'
		},
		deleteWebhookRequest: {
			title: 'Delete webhook request',
			text: 'Do you really want to delete this webhook request?'
		}
	},
	data: {
		team: {
			id: 'Id',
			name: 'Name',
			users_count: '# People',
			events_count: '# Events'
		},
		event: {
			id: 'Id',
			name: 'Name',
			prefix: 'Prefix',
			start_at: 'Start',
			end_at: 'End',
			show_start_at: 'Event start',
			show_end_at: 'Event end',
			is_locked: 'Locked',
			enabled: 'Enabled',
			teams_count: '# Teams',
			users_count: '# People',
			preferred_crs: 'Preferred coordinate system',
			coordinates: 'Coordinates',
			inital_coordinates: 'Initial coordinates'
		},
		user: {
			id: 'Id',
			firstname: 'First name',
			lastname: 'Last name',
			avatar: 'Avatar',
			labels: 'Label',
			email: 'E-mail address',
			role: 'Role',
			roles: 'Roles',
			context_role: 'Role',
			context_roles: 'Roles',
			createdAt: 'Created at',
			last_user_login: 'Last login'
		},
		role: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			description: 'Description',
			permissions: 'Permissions'
		},
		permission: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			description: 'Description'
		},
		context_role: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			context_model_type: 'Context model',
			description: 'Description',
			context_permissions: 'Permissions'
		},
		context_permission: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			context_model_type: 'Context model',
			description: 'Description'
		},
		announcement: {
			id: 'Id',
			title: 'Title',
			type: 'Type',
			description: 'Description',
			url: 'URL',
			start_at: 'Start date',
			end_at: 'End date'
		},
		event_layer: {
			name: 'Name',
			opacity: 'Opacity',
			is_grayscale: 'Grayscale',
			transformation: {
				a0: 'a0',
				b0: 'b0',
				a1: 'a1',
				b1: 'b1',
				a2: 'a2',
				b2: 'b2'
			}
		},
		event_overlay: {
			id: 'Id',
			name: 'Name',
			icon: 'Icon',
			url: 'Url',
			layer: 'Layer',
			format: 'Format',
			opacity: 'Opacity',
			minZoom: 'Zoom factor'
		},
		marker: {
			id: 'Id',
			name: 'Name',
			icon: 'Icon',
			coordinates: 'Coordinates',
			description: 'Description'
		},
		config: {
			card: 'Settings',
			key: 'Key',
			public: 'Public',
			type: 'Type',
			default: 'Default',
			value: 'Value'
		},
		webhook: {
			id: 'Id',
			name: 'Name',
			class: 'Class',
			endpoint: 'API endpoint',
			auth_type: 'Authentication',
			client_id: 'Username',
			client_secret: 'Password',
			requests_count: '# Requests'
		},
		webhook_request: {
			service_id: 'Service',
			action: 'Action',
			ip_address: 'IP',
			dns: 'DNS',
			method: 'Method',
			created_at: 'Time',
			payload: 'Payload',
			data: 'Data',
			success: 'Status'
		}
	},
	tabs: {
		admin_settings: {
			roles_and_permissions: 'Roles & permissions',
			translations: 'Translations',
			templates: 'Templates',
			webhooks: 'Webhooks',
			settings: 'Settings'
		},
		development: {
			tools: 'Tools',
			stores: 'Stores',
			authentication: 'Authentication',
			select: 'Select components',
			phpInfo: 'PHP info',
			redisInfo: 'Redis',
			schemaInfo: 'Schema',
			images: 'Images'
		},
		me: {
			general: 'General',
			notifications: 'Notifications',
			security: 'Security'
		},
		event_settings: {
			map: 'Map',
			markers: 'Markers'
		}
	},
	popovers: {
		event: {
			preferred_crs: {
				title: 'Preferred coordinate system',
				text: 'Coordinate system selected by default for this event.'
			}
		}
	},
	enum: {
		boolean: {
			true: 'Yes',
			false: 'No'
		},
		event_state: {
			active: 'Active',
			inactive: 'Inactive'
		},
		crs: {
			null: '-',
			'EPSG:4326': 'WGS84 (GPS)',
			'EPSG:3857': 'Web Mercator',
			'EPSG:25832': 'UTM Zone 32N',
			'EPSG:25833': 'UTM Zone 33N'
		},
		transformation_input_methode: {
			manual: 'Direct input',
			reference: 'Reference points'
		},
		month_names: {
			undefined: '',
			0: 'January',
			1: 'February',
			2: 'March',
			3: 'April',
			4: 'May',
			5: 'June',
			6: 'July',
			7: 'August',
			8: 'September',
			9: 'October',
			10: 'November',
			11: 'December'
		},
		day_names: {
			0: 'Sunday',
			1: 'Monday',
			2: 'Tuesday',
			3: 'Wednesday',
			4: 'Thursday',
			5: 'Friday',
			6: 'Saturday'
		},
		day_short_names: {
			0: 'Sun',
			1: 'Mon',
			2: 'Tue',
			3: 'Wed',
			4: 'Thu',
			5: 'Fri',
			6: 'Sat'
		}
	},
	notification: {
		assigned_to_team: {
			icon: 'fa-building',
			title: 'Added to team',
			text: "You have been added to the team '{team_name}'."
		},
		assigned_to_event: {
			icon: 'fa-campground',
			title: 'Added to event',
			text: "You have been added to the event '{event_name}'."
		}
	},
	support: {
		subject: '[{app_title}] Support request',
		body: `Hello {app_title} team,

I need support on the page '{uri}'.

Short description:
...

Priority/Affected:
- Priority: (blocker/high/medium/low)
- Affected: (e.g. only me / team / all users)

Expected behavior:
...

Actual behavior:
...

Steps to reproduce:
1) ...
2) ...
3) ...

Environment:
- Browser: ...
- Operating system: ...

Time:
- since: ...
- last observed: ...

Error message / logs:
- ...

You can reach me for questions at: ...

Thank you for your support



Additional data:
{data}
`
	}
};
